import { render, staticRenderFns } from "./JDListItem.vue?vue&type=template&id=2333dd5c&scoped=true&"
import script from "./JDListItem.vue?vue&type=script&lang=js&"
export * from "./JDListItem.vue?vue&type=script&lang=js&"
import style0 from "./JDListItem.vue?vue&type=style&index=0&id=2333dd5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2333dd5c",
  null
  
)

export default component.exports